var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { "separator-class": "el-icon-arrow-right" } },
        [
          _c(
            "el-breadcrumb-item",
            { attrs: { to: { path: "warehouseStock" } } },
            [_vm._v("仓库库存")]
          ),
          _c("el-breadcrumb-item", [_vm._v("库存调整列表")]),
          !_vm.obj.isNewO
            ? _c("el-breadcrumb-item", [_vm._v("填写库存调拨")])
            : _c("el-breadcrumb-item", [_vm._v("重开库存调拨")]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "context" },
        [
          _c("div", { staticClass: "left" }, [
            _c("div", { staticClass: "top" }, [_vm._v("库存调拨")]),
            _c(
              "div",
              { staticClass: "tableBorder" },
              [
                _c("div", { staticClass: "title" }, [
                  _c("span", [
                    _vm._v("调拨编号：" + _vm._s(_vm.table.oddNumber)),
                  ]),
                  _c("span", [
                    _c("span", { staticStyle: { "margin-right": "20px" } }, [
                      _vm._v(
                        "申请人：" + _vm._s(_vm.table.createdByName) + " "
                      ),
                    ]),
                    _c("span", [
                      _vm._v(
                        " 创建时间：" +
                          _vm._s(_vm.$moment(_vm.table.createdTime))
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "el-table",
                  {
                    ref: "moviesTable",
                    attrs: { data: _vm.table.goodsList },
                    on: {
                      "row-click": _vm.openDetails,
                      "selection-change": _vm.selectChange,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "50" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "序号", type: "index", width: "50" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "商品信息", prop: "title" },
                    }),
                    _vm._l(_vm.wareList.list, function (item, index) {
                      return _c("el-table-column", {
                        key: index,
                        attrs: { label: item.name },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.warehouses &&
                                  scope.row.warehouses.find(
                                    (res) => res.warId == item.id
                                  )
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                "open-delay": 300,
                                                effect: "dark",
                                                content: "提交时库存",
                                                placement: "right-start",
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.type == 1
                                                        ? scope.row.warehouses.find(
                                                            (res) =>
                                                              res.warId ==
                                                              item.id
                                                          ).laterQuantity
                                                        : scope.row.warehouses.find(
                                                            (res) =>
                                                              res.warId ==
                                                              item.id
                                                          ).laterQuantity
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                "open-delay": 300,
                                                effect: "dark",
                                                content: "修改库存",
                                                placement: "right-start",
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row.warehouses.find(
                                                        (res) =>
                                                          res.warId == item.id
                                                      ).difference >= 0
                                                        ? "+" +
                                                            scope.row.warehouses.find(
                                                              (res) =>
                                                                res.warId ==
                                                                item.id
                                                            ).difference
                                                        : scope.row.warehouses.find(
                                                            (res) =>
                                                              res.warId ==
                                                              item.id
                                                          ).difference
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                "open-delay": 300,
                                                effect: "dark",
                                                content: "实际库存",
                                                placement: "right-start",
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(" " + _vm._s(0) + " "),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                "open-delay": 300,
                                                effect: "dark",
                                                content: "修改库存",
                                                placement: "right-start",
                                              },
                                            },
                                            [_c("div", [_vm._v("+0")])]
                                          ),
                                        ],
                                        1
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "right" },
            [
              _vm._m(0),
              _vm.selectObj.brandId != undefined || _vm.selectArray.length > 1
                ? _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: { model: _vm.form, "label-width": "80px" },
                    },
                    [
                      _vm.isHideForm
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "商品名称" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  disabled: "",
                                  value: _vm.selectObj.title,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isHideForm
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "库存总数" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  disabled: "",
                                  value: _vm.selectObj.count,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.selectObj.warehouses && _vm.isHideForm
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "仓库数量" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: "",
                                  size: "small",
                                  value: _vm.selectObj.history,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isHideForm
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "调拨仓库" } },
                            [
                              _vm._l(
                                _vm.selectObj.warehouses,
                                function (ite, index) {
                                  return ite.type == 0 || ite.type == undefined
                                    ? _c(
                                        "div",
                                        {
                                          key: index,
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "space-between",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                value: ite.warName,
                                                size: "mini",
                                                "value-key": "id",
                                                placeholder: "请选择",
                                                disabled: ite.type == 0,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.myWareListChange(
                                                    $event,
                                                    ite
                                                  )
                                                },
                                              },
                                            },
                                            _vm._l(
                                              _vm.wareList.list,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.id,
                                                  attrs: {
                                                    label: item.name,
                                                    value: item,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                              },
                                            },
                                            [
                                              _c("el-input-number", {
                                                staticStyle: {
                                                  "margin-right": "10px",
                                                },
                                                attrs: {
                                                  size: "mini",
                                                  min: 0,
                                                  placeholder: "请输入库存数量",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.inputChange(ite)
                                                  },
                                                },
                                                model: {
                                                  value: ite.laterQuantity,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      ite,
                                                      "laterQuantity",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "ite.laterQuantity",
                                                },
                                              }),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-remove-outline",
                                                staticStyle: {
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteMyWare(
                                                      ite,
                                                      ite.type != undefined
                                                        ? 1
                                                        : 0
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                }
                              ),
                              _vm.selectObj.warehouses &&
                              _vm.selectObj.warehouses.length <
                                _vm.wareList.list.length
                                ? _c("i", {
                                    staticClass: "el-icon-circle-plus-outline",
                                    staticStyle: { cursor: "pointer" },
                                    on: { click: _vm.addMyWareList },
                                  })
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "调拨原因" } },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "select",
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择",
                                size: "mini",
                                clearable: "",
                                "value-key": "id",
                              },
                              on: {
                                change: _vm.whySelect,
                                "visible-change": (v) =>
                                  _vm.visibleChange(
                                    v,
                                    "select",
                                    _vm.selectClick
                                  ),
                              },
                              model: {
                                value: _vm.selectObj.tempSelect,
                                callback: function ($$v) {
                                  _vm.$set(_vm.selectObj, "tempSelect", $$v)
                                },
                                expression: "selectObj.tempSelect",
                              },
                            },
                            _vm._l(_vm.whyList.list, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.deliveryName,
                                  value: item,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", { staticClass: "nodate" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../../assets/kong.png"),
                        alt: "",
                      },
                    }),
                    _c("span", [_vm._v("请选择左侧信息")]),
                  ]),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "管理调拨原因",
                "append-to-body": "",
                width: "30%",
                visible: _vm.dialogFormVisible,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogFormVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "dialogContent" },
                [
                  _c(
                    "el-form",
                    { attrs: { "label-width": "80px" } },
                    [
                      _c("el-form-item", { attrs: { label: "添加原因" } }, [
                        _c(
                          "div",
                          { staticClass: "add" },
                          [
                            _c("el-input", {
                              attrs: { size: "mini" },
                              model: {
                                value: _vm.whyValue,
                                callback: function ($$v) {
                                  _vm.whyValue = $$v
                                },
                                expression: "whyValue",
                              },
                            }),
                            _c("i", {
                              staticClass: "el-icon-circle-plus-outline",
                              staticStyle: {
                                "margin-left": "20px",
                                cursor: "pointer",
                              },
                              on: { click: _vm.addWhy },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "whyList",
                      staticStyle: {
                        pading: "2px 0px",
                        height: "405px",
                        overflow: "auto",
                      },
                    },
                    _vm._l(_vm.whyList.list, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticStyle: {
                            "margin-bottom": "5px",
                            display: "flex",
                            "align-items": "center",
                            height: "40px",
                            "padding-left": "10px",
                          },
                          on: {
                            dblclick: function ($event) {
                              return _vm.updateItem($event, item)
                            },
                          },
                        },
                        [
                          _vm.id != item.id
                            ? _c("i", {
                                staticClass: "el-icon-remove-outline",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteWhy(item.id)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.id != item.id
                            ? _c(
                                "span",
                                { staticStyle: { "margin-left": "10px" } },
                                [_vm._v(_vm._s(item.deliveryName))]
                              )
                            : _vm._e(),
                          _vm.id == item.id
                            ? _c("input", {
                                directives: [
                                  { name: "focus", rawName: "v-focus" },
                                ],
                                staticStyle: { height: "40px" },
                                attrs: { type: "text" },
                                on: {
                                  blur: function ($event) {
                                    return _vm.updateBlur(
                                      $event.target.value,
                                      item
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticStyle: { height: "40px" } }),
      _c(
        "div",
        { staticClass: "submit" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.addAllot },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [_c("span", [_vm._v("操作")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }